class ReadMore extends HTMLElement {
  constructor() {
    super();

    /**
      *  Read More JS
      *  Truncates text via specfied character length with more/less actions.
      *  Maintains original format of pre truncated text.
      *
      */

      const ReadMore = (() => {
        let s;

        return {

          settings() {
            return {
              content: document.querySelectorAll('.js-read-more [data-rm-text]'),
              originalContentArr: [],
              truncatedContentArr: [],
              words: document.querySelector('.js-read-more').dataset.rmWords,
              moreLink: document.querySelector('.js-read-more').dataset.rmMorelink,
              lessLink: document.querySelector('.js-read-more').dataset.rmLesslink
            }
          },

          init() {
            s = this.settings();
            this.bindEvents();
          },

          bindEvents() {
            ReadMore.truncateText();
          },

          /**
            * Count Words
            * Helper to handle word count.
            * @param {string} str - Target content string.
            */
          countWords(str) {
            return str.split(/\s+/).length;
          },

          /**
            * Ellpise Content
            * @param {string} str - content string.
            * @param {number} wordsNum - Number of words to show before truncation.
            */
          ellipseContent(str, wordsNum) {
            return str.split(/\s+/).slice(0, wordsNum).join(' ') + '...';
          },

          /**
            * Truncate Text
            * Truncate and ellipses contented content
            * based on specified word count.
            * Calls createLink() and handleClick() methods.
            */
          truncateText() {
            for (let i = 0; i < s.content.length; i++) {

              const originalContent = s.content[i].innerHTML;
              const numberOfWords = s.words;
              const truncateContent = ReadMore.ellipseContent(originalContent, numberOfWords);
              const originalContentWords = ReadMore.countWords(originalContent);

              s.originalContentArr.push(originalContent);
              s.truncatedContentArr.push(truncateContent);

              if (numberOfWords < originalContentWords) {
                s.content[i].innerHTML = s.truncatedContentArr[i];
                let self = i;
                ReadMore.createLink(self)
              }
            }
            ReadMore.handleClick(s.content);
          },

          /**
            * Create Link
            * Creates and Inserts Read More Link
            * @param {number} index - index reference of looped item
            */
          createLink(index) {
            const linkWrap = document.createElement('span');
            const iconDown = 
              `<svg class="icon icon--xs" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="currentColor" fill-rule="evenodd" d="M5.293 8.293a1 1 0 0 1 1.414 0L12 13.586l5.293-5.293a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414Z" clip-rule="evenodd"/>
              </svg>`;

            linkWrap.className = 'read-more__link-wrap';

            linkWrap.innerHTML = `<button type="button" id="read-more_${index}" class="read-more__link button button--link" style="cursor:pointer;">${s.moreLink} ${iconDown}</button>`;

            // Inset created link
            s.content[index].parentNode.insertBefore(linkWrap, s.content[index].nextSibling);

          },

          /**
            * Handle Click
            * Toggle Click eve
            */
          handleClick(el) {
            const readMoreLink = document.querySelectorAll('.read-more__link');

            for (let j = 0, l = readMoreLink.length; j < l; j++) {

              readMoreLink[j].addEventListener('click', function() {

                const moreLinkID = this.getAttribute('id');
                const iconDown = 
                  `<svg class="icon icon--xs" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <path fill="currentColor" fill-rule="evenodd" d="M5.293 8.293a1 1 0 0 1 1.414 0L12 13.586l5.293-5.293a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414Z" clip-rule="evenodd"/>
                  </svg>`;
                const iconUp = 
                  `<svg class="icon icon--xs" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <path fill="currentColor" fill-rule="evenodd" d="M18.707 15.707a1 1 0 0 1-1.414 0L12 10.414l-5.293 5.293a1 1 0 0 1-1.414-1.414l6-6a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414Z" clip-rule="evenodd"/>
                  </svg>`;
                let index = moreLinkID.split('_')[1];

                el[index].classList.toggle('is-expanded');

                if (this.dataset.clicked !== 'true') {
                    el[index].innerHTML = s.originalContentArr[index];
                    this.innerHTML = `${s.lessLink} ${iconUp}`;
                    this.dataset.clicked = true;
                } else {
                  el[index].innerHTML = s.truncatedContentArr[index];
                  this.innerHTML = `${s.moreLink} ${iconDown}`;
                  this.dataset.clicked = false;
                }
              });
            }
          },

          /**
            * Open All
            * Method to expand all instances on the page.
            */
          openAll() {
            const instances = document.querySelectorAll('.read-more__link');
              for (let i = 0; i < instances.length; i++) {
                content[i].innerHTML = s.truncatedContentArr[i];
                instances[i].innerHTML = s.moreLink;
              }
            }
          }
      })();

      ReadMore.init()

  }
}
if (!customElements.get('read-more')) {
  customElements.define('read-more', ReadMore);
}